// A call's found / not found / error chip (2026-10-29; docs/contact-view.md),
// shared by the Activity Log row (ConversationActivity.jsx) and each row of
// the View calls modal (ViewCalls.jsx), so the two always agree. Which
// status is callStatus() in viewCalls.js; a planned call gets no chip.
//
// The Activity Log row shows an error with the API's own message and code
// (callErrorText, 2026-10-27), wrapped so it reads without opening the call.
// compact (the modal's collapsed row): a short "error" chip that keeps the
// row's height, the full message in its title and in the expanded Error
// Detail.
import { Chip } from '@mui/material'
import { callErrorText } from './failureLabels.js'
import { callStatus } from './viewCalls.js'

const COMPACT_SX = { height: 18, fontSize: 11, flexShrink: 0, '& .MuiChip-label': { px: 0.75 } }

export default function CallStatusChip({ call, logged = true, compact = false, testId }) {
  const status = callStatus(call, { logged })
  if (!status) return null
  const statusProps = { 'data-call-status': status, ...(testId ? { 'data-testid': testId } : {}) }
  if (status === 'error') {
    if (compact) return <Chip size="small" color="error" label="error" title={callErrorText(call)} sx={COMPACT_SX} {...statusProps} />
    return call.errorMessage
      ? <Chip size="small" color="error" data-testid="call-error-message" data-call-status={status} label={callErrorText(call)} sx={{ height: 'auto', maxWidth: '100%', '& .MuiChip-label': { whiteSpace: 'normal', wordBreak: 'break-word', py: 0.25 } }} />
      : <Chip size="small" color="error" label={callErrorText(call)} {...statusProps} />
  }
  if (status === 'not_ready') {
    return <Chip size="small" color="warning" variant="outlined" label="not ready yet" sx={compact ? COMPACT_SX : undefined} {...statusProps} />
  }
  const found = status === 'found'
  return (
    <Chip size="small" color={found ? 'success' : 'default'} variant="outlined" label={found ? 'found' : 'not found'}
      sx={compact ? COMPACT_SX : undefined} {...statusProps} />
  )
}
